import * as LottiePlayer from "@lottiefiles/lottie-player";
import { isSpSize } from "../common/utils/isSpSize";

class Last {
  // ---------------------------------------------------------------------------
  // --	Last
  // ---------------------------------------------------------------------------

  constructor() {
    //DOM参照
    this.$elm = document.querySelector(".p-home-last");
    this.$sticky = this.$elm.querySelector(".p-home-last__sticky");

    //lottieの準備
    this.isPlayed = false;
    this.isReady = false;
    this.player = document.querySelector(".js-lottie-mark");
    this.player.addEventListener("ready", () => {
      this.isReady = true;
    });

    //Timeline生成
    this.tl = gsap.timeline().pause();
    const lines = this.$elm.querySelectorAll(
      isSpSize() ? ".-line-md" : ".-line"
    );
    lines.forEach((line) => {
      gsap.set(line, {
        alpha: 0,
        y: 100,
      });
      this.tl.to(
        line,
        {
          alpha: 1,
          y: 0,
          ease: "power1.out",
          duration: 1,
        },
        "<+=0.1"
      );
    });
    this.lineH = lines[0].offsetHeight;
    if (!isSpSize()) this.lineH *= 1.5;
    this.lineNum = lines.length;

    //スクロールハンドリング
    window.addEventListener("scroll", this.update.bind(this));

    //リサイズハンドリング
    window.addEventListener("resize", this.update.bind(this));

    //初回アップデート
    this.update();
  }

  update() {
    //スクロール量とWindowの高さ
    const scrollY = window.scrollY;
    const windowH = window.innerHeight;

    //LASTエリアのY座標
    const targetY = -this.$elm.getBoundingClientRect().y;

    //メッセージ表示判定用座標
    const msgStartY = windowH * 2.5;
    const msgEndY = isSpSize ? windowH * 3.5 : windowH * 4.5;

    //メッセージ表示
    let msgRate = (targetY - msgStartY) / (msgEndY - msgStartY);
    if (msgRate < 0) {
      msgRate = 0;
    } else if (msgRate > 1) {
      msgRate = 1;
    }
    this.tl.progress(msgRate);

    //メッセージを位置固定
    if (-(targetY - this.$elm.getBoundingClientRect().height) < windowH * 2) {
      this.$sticky.classList.add("fix");
    } else {
      this.$sticky.classList.remove("fix");
    }

    //Lottieの準備前はここまで
    if (!this.isReady) return;

    //マーク判定用座標
    const markStartY = windowH * 1.5;
    const markEndY = windowH * 2.5;

    //マークの表示制御
    if (targetY > markStartY && !this.isPlayed) {
      this.isPlayed = true;
      this.player.play();
    } else if (targetY < -windowH && this.isPlayed) {
      this.isPlayed = false;
      this.player.stop();
      this.player.seek(0);
    }
  }

  // ---------------------------------------------------------------------------
}

export default Last;
